export enum TOOLTIP_ICON {
  DISCOUNT = 'discount',
  INFO = 'info',
}
